import { render, staticRenderFns } from "./SelectLanguage.vue?vue&type=template&id=67fec9d8&"
import script from "./SelectLanguage.vue?vue&type=script&lang=js&"
export * from "./SelectLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports